import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const UserForm_CreateUser_Mutation = graphql(`
  mutation UserForm_CreateUser(
    $personId: Id!
    $email: EmailAddress!
    $globalRoleIds: [Id!]!
  ) {
    createUser(
      personId: $personId
      email: $email
      globalRoleIds: $globalRoleIds
    ) {
      user {
        _id
      }
      password
    }
  }
`);

export const useCreateUserMutation = () =>
  useGraphQLMutation(UserForm_CreateUser_Mutation);
